import { useState, useEffect } from 'react';

/**
 * Hook do zarządzania stylem mapy z localStorage i nasłuchiwaniem zmian
 * @returns {string} mapStyle - aktualny styl mapy
 */
export function useMapStyle() {
  const [mapStyle, setMapStyle] = useState(() => {
    try {
      const saved = localStorage.getItem('mapStyle');
      if (saved && ['subtle', 'dark', 'light', 'monochrome', 'default'].includes(saved)) {
        return saved;
      }
    } catch (err) {
      console.warn('Failed to load map style from localStorage:', err);
    }
    return 'monochrome';
  });

  // Nasłuchiwanie zmian stylu mapy z ustawień
  useEffect(() => {
    const handleMapStyleChange = (event) => {
      const newStyle = event.detail?.style;
      if (newStyle && ['subtle', 'dark', 'light', 'monochrome', 'default'].includes(newStyle)) {
        setMapStyle(newStyle);
      }
    };

    window.addEventListener('mapStyleChanged', handleMapStyleChange);
    return () => window.removeEventListener('mapStyleChanged', handleMapStyleChange);
  }, []);

  return mapStyle;
}

export default useMapStyle;
